import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/traversal/index/index.js";
import "dabbyjs/src/traversal/eq/eq.js";
import "dabbyjs/src/events/trigger/trigger.js";

export default (obj, submit) => {
	const len = obj.length;
	if (len) {
		const control = ["Backspace", "ArrowLeft", "ArrowRight"];
		obj

			// only allow entering letters
			.on("keydown", e => {
				if (!control.includes(e.key) && Number.isNaN(parseInt(e.key))) {
					e.preventDefault();
				}
			})

			// move to next letter box on input, where the value is not deleted
			.on("input", function (e) {
				const $this = $(this),
					value = $this.val();
				if (value !== "") {

					// make sure they haven't typed too much
					if (value.length > 1) {
						$this.val(value.substr(0, 1));
					}

					// go to next input
					const index = obj.index(this);
					if (obj[index + 1]) {
						obj.eq(index + 1).trigger("focus").get(0).select();

					// submit when entered
					} else {
						submit.addClass(submit.get(0).classList[0] + "--loading").trigger("click");
					}
				}
			})

			// move back on leftarrow and backspace, forward on right arrow
			.on("keyup", function (e) {
				if (control.includes(e.key)) {
					const move = obj.index(this) - (e.key === "ArrowRight" ? -1 : 1);

					// move to next box
					if (obj[move]) {
						obj.eq(move).trigger("focus").get(0).select();
					}
				}
			})
			
			// focus the first element
			.eq(0).trigger("focus");
	}
};